import getTerritoryPageUrl from 'src/services/pagesUrl/getTerritoryPageUrl';
import { getPromptPageUrl } from 'src/services/pagesUrl/getPromptPageUrl';
import { getArticlePageUrl } from 'src/services/pagesUrl/getArticlePageUrl';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { usePromptPageContext } from '../Prompt/context/PromptPageContext';
import { DEFAULT_TERRITORY_LOGO } from '../TerritoryHeader/constants';
import { DEFAULT_ARTICLE_IMAGE } from '../ArticleCard/constants';
import { BreadcrumbLink } from '../Breadcrumbs/BreadcrumbLink';
import { BreadcrumbImageAdornment } from '../Breadcrumbs/BreadcrumbImageAdornment';

export const PromptReplyPreviewBreadcrumbs = () => {
  const {
    prompt: promptQuery,
    preview: {
      state: { articleId },
    },
  } = usePromptPageContext();
  const article = promptQuery?.data?.article.childArticles?.find((article) => article.id === articleId);
  const prompt = promptQuery?.data?.article;
  const territory = prompt?.territory;

  return (
    <Breadcrumbs>
      <BreadcrumbLink
        leftAdornment={
          <BreadcrumbImageAdornment
            src={DEFAULT_TERRITORY_LOGO || territory?.logo?.publicUrl}
            alt={territory?.name || 'Territory logo'}
            width={16}
            height={16}
            rounded="full"
          />
        }
        href={getTerritoryPageUrl(territory?.slug!)}
        // eslint-disable-next-line react/no-children-prop, react/jsx-no-useless-fragment
        children={<></>}
      />
      <BreadcrumbLink
        leftAdornment={
          <BreadcrumbImageAdornment
            rounded="sm"
            src={prompt?.coverImage?.publicUrlTransformed! || DEFAULT_ARTICLE_IMAGE}
            alt={prompt?.title || 'Prompt image'}
          />
        }
        href={getPromptPageUrl(prompt?.slug)}
      >
        {prompt?.title}
      </BreadcrumbLink>
      <BreadcrumbLink
        leftAdornment={
          <BreadcrumbImageAdornment
            rounded="sm"
            src={article?.coverImage?.publicUrlTransformed! || DEFAULT_ARTICLE_IMAGE}
            alt={article?.title || 'Article image'}
          />
        }
        href={getArticlePageUrl(article?.slug)}
      >
        {article?.title}
      </BreadcrumbLink>
    </Breadcrumbs>
  );
};
